import { Mail, MapPin, PhoneCallIcon } from "lucide-react";
import { FooterItems } from "../data/index";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";
//import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
// @ts-ignore
import markerIcon from '../../node_modules/leaflet/dist/images/marker-icon-2x.png';
//import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Configurar el icono del marcador
const defaultIcon = L.icon({
  iconUrl: markerIcon,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});


const position: [number, number] = [-26.83606661691036, -65.20549197424275];

const Footer = () => {
  return (
    <div>
      <footer className="bg-gray-800 text-white p-8">
        {/* Contenedor de las 3 secciones */}
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Sección de Encontranos */}
          <div>
            <h1 className="text-xl mb-4">Encontranos</h1>
            <MapContainer
              center={position}
              zoom={25}
              style={{ height: "400px", width: "100%", zIndex: 1 }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <Marker position={position} icon={defaultIcon}>
                <Popup>Oficinas</Popup>
              </Marker>
            </MapContainer>
          </div>

          {/* Sección de Contacto */}
          <div>
            <h1 className="text-xl mb-4">Contacto</h1>
            <div className="flex flex-col space-y-4">
              <div className="flex items-center">
                <PhoneCallIcon className="mr-2" />
                <p>+54 9 3816 72-8112</p>
              </div>
              <div className="flex items-center">
                <Mail className="mr-2" />
                <p>gisebarbero@gmail.com</p>
              </div>
              <div className="flex items-center">
                <MapPin className="mr-2" />
                <p>Pasaje 2 de Abril 337 - Piso 7 of 74, San Miguel de Tucumán</p>
              </div>
            </div>
          </div>

          {/* Sección de Enlaces */}
          <div>
            <h1 className="text-xl mb-4">Enlaces</h1>
            <ul className="space-y-2">
              {FooterItems.map((item, index) => (
                <li key={index}>
                  <a href={item.href} className="hover:underline">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Línea de separación y Copyright */}
        <hr className="border-t border-gray-500 my-8" />
        <div className="text-center text-sm">
          © {new Date().getFullYear()} Gisela Barbero Estudio Jurídico. Todos
          los derechos reservados. Prohibida su reproducción total o parcial.
        </div>
      </footer>
    </div>
  );
};

export default Footer;
